import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';

import { AppPropertiesService } from '../../../services/app-properties/app-properties.service';

/**
 * Component for the maintenance page.
 *
 * @author Mike Wood e011131
 */
@Component({
	selector: 'claim-tracker-maintenance',
	templateUrl: './maintenance.component.html',
	imports: [RouterLink],
	styleUrls: ['./maintenance.component.css']
})
export class MaintenanceComponent implements OnInit {
	aoMaintenanceImgUrl: string;

	/**
	 * @param appPropertiesService the global app properties service
	 */
	constructor(private appPropertiesService: AppPropertiesService) {}

	/**
	 * Called when the component is initialized.
	 */
	ngOnInit() {
		this.aoMaintenanceImgUrl = this.appPropertiesService.appProperties.aoMaintenanceImgUrl ?? '';
	}
}
